import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import { datetimeShortFromUTC } from 'utils/dayjs';
import Icon from 'components/Icon';
import './index.sass';

const { block, el } = bem('transfer-chip', 'event-chip');
const TransferEventChip = ({event, number, openTransferForm }) => {

    const eventFormat = (utcDate) => {
        const { date, time } = datetimeShortFromUTC(utcDate);
        return `${ date } ${ time }`;
    };

    return (
        <div className={ block({disabled: event.hasPassed }) }>
            <div className={ el('content')}>
                <Text className={ el('number') }>#{ number + 1 }</Text>
                <Text className={ el('date') }>{ eventFormat(event.startDate) }</Text>
            </div>
            { event.isTransferEnabled && <div className={el('context')} >
                <div className={el('button')} onClick={openTransferForm}>
                    <Icon name={'pencil'} />
                </div>
            </div> }
        </div>
    )
}

export default TransferEventChip;
